import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { LoginObserverService } from '../../shared/authentication/login-observer.service';
import { User } from '../models/user';
import { UserLogout } from '../models/user-logout';

@Injectable({
    providedIn: 'root'
})
export class CurrentUserService {
    private currentUser: User;

    userChangedObserverSubject: Subject<User> = new Subject<User>();
    userLoggedOutObserverSubject: Subject<UserLogout> = new Subject<UserLogout>();

    /**
    * Subscribe to events when the current user changes
    */
    public userChangedObserver = this.userChangedObserverSubject.asObservable();

    constructor(loginObserverService: LoginObserverService) {
        loginObserverService.logoutObserver.subscribe(triggeredByUser => {
            this.userLoggedOutObserverSubject.next(new UserLogout(this.currentUser, triggeredByUser));
            this.setCurrentUser(null);
        });
    }

    getCurrentUser(): User {
        return this.currentUser;
    }

    hasCurrentUser(): boolean {
        return this.currentUser !== null && this.currentUser !== undefined;
    }

    setCurrentUser(user: User) {
        this.currentUser = user;
        this.userChangedObserverSubject.next(user);
    }

    isCurrentLoginedUser(userId: number): boolean {
        return userId === this.currentUser.UserId;
    }

    get isAzureADUser(): boolean {
        return !!this.currentUser?.Credentials?.DomainAccountName?.startsWith('oid');
    }

    /**
     * Checks if the current user has the given permission.
     * @param permission
     */
    hasPermission(permission: string): boolean {
        return this.currentUser ? User.hasPermission(permission, this.currentUser) : false;
    }

    /**
     * Checks if the current user has all the given permissions
     * @param permissions
     */
    hasPermissions(permissions: string[]): boolean {
        return permissions.reduce((hasPermission, permission) => hasPermission && this.hasPermission(permission), true);
    }
}
